export default __webpack_public_path__ + "static/loop-balthazaurus-scroll-d519aa7a2be844d6e524b3fb9fdc9b1c.mp4";